import { useEffect } from 'react';
import { retainSupportRef } from './context';

/** Registers what this component shows for as long as it is mounted (#472). */
export function useSupportRef(kind: 'session' | 'occurrence', id?: string | null) {
  useEffect(() => retainSupportRef(kind, id), [kind, id]);
}

/** The same, for a row inside a list, where a hook cannot be called: render it beside the row's trace link. */
export function SupportRef({ session, occurrence }: { session?: string | null; occurrence?: string | null }) {
  useSupportRef(session ? 'session' : 'occurrence', session || occurrence);
  return null;
}
